import React, {useCallback} from 'react';
import PropTypes from 'prop-types';
import MotifInput from '@ey/motif-react-wrapper/Input';
import styled from 'styled-components';
import {labels} from '../../../util/utils';

Input.propTypes = {
	className: PropTypes.string,
	disabled: PropTypes.bool,
	id: PropTypes.string.isRequired,
	required: PropTypes.bool,
	onBlur: PropTypes.func,
	onChange: PropTypes.func,
	onFocus: PropTypes.func,
	onKeyDown: PropTypes.func,
	placeholder: PropTypes.string,
	type: PropTypes.oneOf(['date', 'email', 'number', 'text', 'password', 'tel']),
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	hideClearButton: PropTypes.bool,
	clearButtonTitle: PropTypes.string,
	autoFocus: PropTypes.bool,
	maxLength: PropTypes.number,
	minLength: PropTypes.number,
	pattern: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(RegExp)]),
	returnOnlyInput: PropTypes.bool,
	suffix: PropTypes.oneOfType([PropTypes.element, PropTypes.oneOf([null])]),
};

Input.defaultProps = {
	className: 'styled-input',
	disabled: false,
	required: false,
	type: 'text',
	hideClearButton: true,
	clearButtonTitle: labels.clear,
	autoFocus: false,
	returnOnlyInput: false
};

export default function Input(props) {
	const {
		id,
		className,
		type,
		required,
		step,
		inputmode,
		clearButtonTitle,
		disabled,
		autocomplete,
		placeholder,
		value,
		pattern,
		minLength,
		maxLength,
		autoFocus,
		onChange,
		onClick,
		onKeyDown,
		onBlur,
		onFocus,
		onPaste,
		hideClearButton,
		labelPosition ='in',
		suffix,
		title
	} = props;

	const handleOnChange = useCallback(
		(event) => {
			if (onChange) {
				if (!pattern || (pattern && (!event.target.value || testRegExp(event.target.value, pattern)))) {
					onChange(event);
				}
			}
		},
		[onChange, pattern]
	);

	return (
		<StyledInput
			id={id}
			labelPosition={labelPosition}
			className={className}
			type={type}
			required={required}
			step={step}
			inputmode={inputmode}
			clearButtonTitle={clearButtonTitle}
			disabled={disabled}
			autocomplete={autocomplete}
			placeholder={placeholder}
			value={value || ''}
			pattern={pattern}
			minlength={minLength}
			maxlength={maxLength}
			autoFocus={autoFocus}
			onChange={handleOnChange}
			onClick={onClick}
			onKeyDown={onKeyDown}
			onBlur={onBlur}
			onFocus={onFocus}
			onPaste={onPaste}
			title={title}
			hideClearButton={hideClearButton}
			suffix={suffix}
		/>
	);
}

function testRegExp(value, pattern) {
	if (pattern instanceof RegExp) {
		return pattern.test(value);
	}
	const regExp = new RegExp(pattern);
	return regExp.test(value);
}

const StyledInput = styled(MotifInput)`
	min-height: var(--px-45) !important;
	width: 100%;
	/* Hide arrows for numeric inputs */
	&::-webkit-outer-spin-button,
	&::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}
`;
